import React from 'react';
import { X } from 'react-bootstrap-icons';

import {
  Container,
  Name,
  Info,
  Remove,
  Retry,
  Wrapper,
  Failed
} from './FileStyles';

type Props = {
  status: string;
};

export const File: React.FC<Props> = ({ status }) => {
  return (
    <Container>
      <Wrapper failed={status === 'failed'}>
        <Name>
          NIB_Bulk_Upload_Template.xlxs
        </Name>
        {status === 'failed' && (
          <Failed>Failed</Failed>
        )}
        {status === 'success' && (
          <Info>
            1.6MB
          </Info>
        )}
      </Wrapper>
      <Remove>
        <X size={18} color='#999999' />
      </Remove>
      <Retry>
        {status === 'failed' && 'Retry'}
      </Retry>
    </Container>
  );
};